module.exports = __webpack_public_path__ + "4b87088377525e41099f5863d108290f.jpg";